export const startFetchingCurrencyRate = () => {
  return {
    type: 'START_FETCHING_CURRENCY_RATE',
  };
};

export const finishedFetchingCurrencyRate = (currencies: {
  [currency: string]: number;
}) => {
  return {
    type: 'DONE_FETCHING_CURRENCY_RATE',
    payload: currencies,
  };
};

export default {
  startFetchingCurrencyRate,
  finishedFetchingCurrencyRate,
};
